import {createContext} from 'react'

const CatTipoRecepcionContext = createContext()

export default CatTipoRecepcionContext